///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.event = abcsetup.event || {};
abcsetup.event.workflow = abcsetup.event.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Variables
//
///////////////////////////////////////////////////////////////////////////////////////////////////


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.event.workflow = {
    init: function () {
        abcsetup.setTitle('Approve/Reject Events');

        abcsetup.events.common.init();
        
        $(document).on('submit', 'form', function (e) {

            let has_errors = false;

            if($(document.activeElement).val() === 'cancel')
                return true;

            const rejected = $('tr.rejected');
            if (rejected.length > 0) {
                rejected.each(function () {
                    const row = $(this);
                    const reason = row.next('tr.reject_reason').find('textarea');
                    const error = row.next('tr.reject_reason').find('div.error');
                    reason.removeClass('is-invalid');
                    error.hide();
                    if(reason.val().length === 0) {
                        reason.addClass('is-invalid');
                        error.show();
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this).offset().top
                        }, 1000);
                        has_errors = true;
                    }
                });
            }

            if(has_errors)
                return false;

            return true;
        });
    },
}
